import { GET_STEPS, GET_STEP } from "./const";

export default {

    [GET_STEPS](state) {
        return state.steps;
    },

    [GET_STEP](state) {
        return state.step;
    }
}